var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: "100%",
    height: "100%",
    viewBox: "0 0 31.806 31.806",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.286 12.465C0.601 12.728 0.115 13.344 0.018 14.071C-0.078 14.799 0.231 15.52 0.824 15.951L7.316 20.675L30.374 2.534L9.985 22.621L18.86 29.079C19.424 29.489 20.153 29.612 20.824 29.409C21.494 29.205 22.028 28.696 22.268 28.041L31.762 2.055C31.858 1.791 31.79 1.496 31.59 1.299C31.391 1.102 31.096 1.04 30.832 1.141L1.286 12.465Z",
    fill: "var(--fill-0, #5D7285)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.774 22.246L5.829 22.547L7.089 29.436C7.183 29.948 7.525 30.377 8.001 30.584C8.477 30.79 9.026 30.746 9.462 30.465C11.217 29.333 13.509 27.831 13.447 27.743L5.774 22.246Z",
    fill: "var(--fill-0, #5D7285)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendSymbol);
export default __webpack_public_path__ + "static/media/send-symbol.657eb798c668b3d0e4bb355f8b427527.svg";
export { ForwardRef as ReactComponent };